import { GetActiveVendors } from '../Repositories/AssetRepositoryAsync';
import { SaveConsentedVendors, GetConsentedVendors } from '../Repositories/ConsentedVendorsRepository';

const HasActiveVendorChanged = async (): Promise<boolean> => {
  const activeVendors = await GetActiveVendors();
  const consentedVendors = GetConsentedVendors();

  if (activeVendors.activeVendorListVersion === null || consentedVendors === null) return false;

  if (activeVendors.activeVendorListVersion > consentedVendors) return true;

  return false;
};

const SaveCurrentVendorSnapshot = async (): Promise<void> => {
  const activeVendors = await GetActiveVendors();
  await SaveConsentedVendors(activeVendors.activeVendorListVersion);
};

export { HasActiveVendorChanged, SaveCurrentVendorSnapshot };
